module.exports = __webpack_public_path__ + "img/permission.46879045.svg";